import React from "react"
import "./style.css"

const Skeleton: React.FC<{
    loading: boolean
    small?: boolean
    size?: string | number
    children?: React.ReactNode
    className?: string
}> = ({ small, loading, children, size, className }) => {
    return (
        <React.Fragment>
            {
                loading ?
                    <div
                        style={size ? { height: size } : void 0}
                        className={`rellpay-skeleton${small ? " rellpay-skeleton-small" : ""} ${className && className}`}></div> :
                    children
            }
        </React.Fragment>
    )
}

export default Skeleton
